import Api from "./api.service";

class Auth {
  static login(email, password) {
    return Api.post("/api/v1/login", { user: { email, password } });
  }
  static logout() {
    return Api.delete("/api/v1/logout");
  }
  static getCurrentUser(options = {}) {
    return Api.get("/api/v1/me", options);
  }
}

const AuthService = Object.freeze(Auth);
export default AuthService;
